import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import PageWrapper from "../../components/PageWrapper";
import ElearningGrid from "../../sections/academy/ElearningGrid";
import CTA from "../../sections/landing4/CTA";
import data from "../../data/elearning-modules.json";
import { trackEvent } from "../../lib/elearning";

const ElearningIndex = () => {
  useEffect(() => {
    trackEvent("elearning_index_view", { count: data.modules.length });
  }, []);
  return (
    <PageWrapper>
      <Helmet>
        <title>E-Learning — Dioscuro Academy</title>
        <meta
          name="description"
          content="Short, dense, opinionated DevOps courses. Free preview per module, AI mentor scoped to the curriculum."
        />
        <meta property="og:title" content="E-Learning — Dioscuro Academy" />
        <meta
          property="og:description"
          content="Short, dense, opinionated DevOps courses with free previews and an AI mentor."
        />
      </Helmet>
      <ElearningGrid modules={data.modules} />
      <CTA />
    </PageWrapper>
  );
};

export default ElearningIndex;
